







































import { defineComponent, PropType, ref, watch } from '@nuxtjs/composition-api'
import BlockText from '../BlockText.vue'
import RegionSelect from './RegionSelect.vue'
import CitySelect from './CitySelect.vue'
import OfficeSelect from './OfficeSelect.vue'
import { CityModel } from '@/contracts/api/QueryCites/QueryCities.Response'
import { RegionModel } from '@/contracts/api/QueryRegion/QueryRegion.Response'
import {
  BehaviorOffice,
  BehaviorOfficeSchedule,
  OfficeModel,
} from '@/contracts/api/QueryOffices/QueryOffices.Response'

export default defineComponent({
  name: 'BlockNearestOffice',
  components: {
    BlockText,
    RegionSelect,
    CitySelect,
    OfficeSelect,
  },
  props: {
    productType: {
      type: String,
      default: null,
    },
    officeType: {
      type: String,
      default: null,
    },
    modelId: {
      type: String,
      default: '',
    },
    value: {
      type: Object,
      default: () => ({}),
    },
    error: {
      type: [Boolean, String] as PropType<string | false>,
      default: '',
    },
    // Регионы из админки
    isRegionsFromAdmin: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const selectedRegion = ref<RegionModel | null>()
    const selectedCity = ref<CityModel | null>()
    const selectedOffice = ref<OfficeModel | null>()
    const officeSchedule = ref<string>()

    watch(selectedRegion, () => {
      selectedCity.value = null
    })

    watch(selectedCity, () => {
      selectedOffice.value = null
    })

    watch(selectedOffice, (newOffice) => {
      if (newOffice) {
        officeSchedule.value = getWorkTime(newOffice.value)
        emit('input-change', {
          ...newOffice.value,
          REGION: selectedRegion.value.name,
        })
      } else {
        officeSchedule.value = ''
        emit('input-change', null)
      }
    })

    const clearVariable = (type: string): void => {
      if (type === 'office') {
        selectedOffice.value = null
      } else if (type === 'city') {
        selectedCity.value = null
      } else {
        selectedRegion.value = null
      }
    }

    const getWorkTime = (officeModel: OfficeModel): string => {
      const timeJSON = officeModel?.BEHAVIOURJSON

      if (timeJSON) {
        const time = JSON.parse(timeJSON) as BehaviorOffice

        return Object.values(time.Schedule)
          .sort((v) => Number(!v.IsWorkingDay))
          .reduce(
            (acc: string, schedule) => acc + scheduleDataToString(schedule),
            '<h3>График работы</h3>'
          )
      } else {
        return ''
      }
    }

    const scheduleDataToString = (data: BehaviorOfficeSchedule) => {
      let result: string = ''
      result += '<p>'
      result += data.ShortDayName + ': '

      if (data.IsWorkingDay) {
        const hasLunch = !!data.LunchFinishTime && !!data.LunchStartTime

        result += `${data.StartTime} – ${data.FinishTime}, `
        result += hasLunch
          ? `перерыв: ${data.LunchStartTime} – ${data.LunchFinishTime};`
          : 'без перерыва;'
      } else {
        result += 'вых.'
      }

      result += `</p>`

      return result
    }

    return {
      selectedRegion,
      clearVariable,
      selectedCity,
      selectedOffice,
      officeSchedule,
    }
  },
})
